/**
 * The Home page's words that depend on the clock or a count — pure, so they
 * can be tested without rendering.
 */

/** "Good morning / afternoon / evening", by the browser's local hour. */
export function greeting(now: Date): string {
  const hour = now.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
}

/** The first word of a display name: "Maria Lindqvist" → "Maria". */
export function firstName(displayName: string | null | undefined): string {
  return (displayName ?? "").trim().split(/\s+/)[0] ?? "";
}

const DATE_LINE = new Intl.DateTimeFormat("en-GB", {
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
});

/** "Sunday 25 October 2026". */
export function dateLine(now: Date): string {
  return DATE_LINE.format(now).replace(",", "");
}

/** "3 things are waiting on you" — or nothing while the count is unknown. */
export function waitingLine(count: number | null): string {
  if (count === null) return "";
  if (count === 0) return "Nothing is waiting on you";
  return count === 1 ? "1 thing is waiting on you" : `${count} things are waiting on you`;
}
